export interface Topic {
  id: string;
  title: string;
  desc: string;
  image: string;
  href: string;
  count: number;
}

export const topics: Topic[] = [
  {
    id: "annual-blockbusters",
    title: "年度大片盘点",
    desc: "集结本年度讨论度最高的院线大片，一次看个够。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20action%20movie%20collage%20artwork%2C%20dramatic%20explosions%20and%20city%20skyline%20at%20night%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20film%20grain%20texture%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20premium%20mood%2C%20no%20typography&width=800&height=450&seq=topic-01&orientation=landscape",
    href: "/category/movie",
    count: 8,
  },
  {
    id: "chinese-drama-hits",
    title: "热门国产剧",
    desc: "口碑与人气双高的国产剧集，追剧党的下饭首选。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20drama%20artwork%2C%20ancient%20courtyard%20and%20modern%20city%20split%20composition%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20film%20grain%20texture%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20premium%20mood%2C%20no%20typography&width=800&height=450&seq=topic-02&orientation=landscape",
    href: "/category/tvshow",
    count: 6,
  },
  {
    id: "suspense-collection",
    title: "高分悬疑合集",
    desc: "层层反转、烧脑到最后一秒的悬疑犯罪佳作。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20suspense%20artwork%2C%20foggy%20narrow%20street%20with%20a%20lone%20silhouette%20and%20long%20shadows%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20film%20grain%20texture%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20premium%20mood%2C%20no%20typography&width=800&height=450&seq=topic-03&orientation=landscape",
    href: "/search?genre=%E6%82%AC%E7%96%91",
    count: 4,
  },
  {
    id: "sci-fi-worlds",
    title: "科幻未来世界",
    desc: "星辰大海与未来都市，带你进入想象力最远的边界。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20artwork%2C%20giant%20planet%20and%20spaceship%20over%20a%20futuristic%20city%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20film%20grain%20texture%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20premium%20mood%2C%20no%20typography&width=800&height=450&seq=topic-04&orientation=landscape",
    href: "/search?genre=%E7%A7%91%E5%B9%BB",
    count: 6,
  },
  {
    id: "costume-epics",
    title: "古装传奇大赏",
    desc: "快意江湖与庙堂风云，东方美学的极致呈现。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20ancient%20Chinese%20epic%20artwork%2C%20silk%20robes%20and%20swords%20before%20a%20misty%20palace%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20film%20grain%20texture%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20premium%20mood%2C%20no%20typography&width=800&height=450&seq=topic-05&orientation=landscape",
    href: "/search?genre=%E5%8F%A4%E8%A3%85",
    count: 5,
  },
  {
    id: "asia-hits",
    title: "日韩热播精选",
    desc: "细腻情感与紧凑节奏兼备的日韩口碑剧集与电影。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20Asian%20drama%20artwork%2C%20soft%20glowing%20city%20lanterns%20and%20cherry%20blossoms%20at%20dusk%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20film%20grain%20texture%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20premium%20mood%2C%20no%20typography&width=800&height=450&seq=topic-06&orientation=landscape",
    href: "/search?region=%E6%97%A5%E9%9F%A9",
    count: 3,
  },
];